module.exports = __webpack_public_path__ + "static/media/farm.b7f14dbb.svg";